import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import colors, { withOpacity } from '@wecasa/common/src/utils/colors';
import { toRem } from '@wecasa/common/src/utils/styles';

import { translate } from '@wecasa/i18n';

import Title from '@wecasa/web-ui/src/components/base-text/variants/title';
import Icon from '@wecasa/web-ui/src/components/icon/icon';
import AccessibleModal from '@wecasa/web-ui/src/components/modal/accessible-modal';
import { slideDown, slideUp } from '@wecasa/web-ui/src/components/modal/common';
import ModalContainerWithBackdrop, {
  MODAL_ANIMATION_DURATION,
} from '@wecasa/web-ui/src/components/modal/modal-container-with-backdrop';

import { HEADER_HEIGHT } from '../main-container/header';

const t = translate('containers.basket.icon');

const ModalContent = styled(AccessibleModal)`
  position: fixed;
  top: ${toRem(HEADER_HEIGHT)};
  left: auto;
  right: 0;
  width: 100%;
  height: calc(
    100% - ${toRem(HEADER_HEIGHT)} - ${({ $navigationContainerHeight }) => toRem($navigationContainerHeight)}
  );
  box-shadow: 0 ${toRem(2)} ${toRem(20)} ${withOpacity(colors.neutral100, 0.1)};
  border-radius: ${toRem(30)} ${toRem(30)} 0 0;
  animation: ${({ $open }) => ($open ? slideUp : slideDown)} ${MODAL_ANIMATION_DURATION}ms ease forwards;
  overflow-y: auto;
  background-color: ${colors.white100};
`;

const IconWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${toRem(30)} 0;
  background-color: ${colors.white100};
`;

const StyledTitle = styled(Title.MD.Primary)`
  margin: 0 ${toRem(15)} ${toRem(20)};
`;

type BasketModalProps = PropsWithChildren<{
  onClose?: () => void;
  isOpen: boolean;
  title: string;
  navigationContainerHeight: number;
}>;

const BasketModal = ({ onClose, isOpen, title, navigationContainerHeight, children }: BasketModalProps) => (
  <ModalContainerWithBackdrop isOpen={isOpen} onClose={onClose} zIndex={99}>
    <ModalContent $open={isOpen} $navigationContainerHeight={navigationContainerHeight}>
      <IconWrapper onClick={onClose}>
        <Icon name='arrow-down' size={15} color={colors.neutral100} title={t('.close')} />
      </IconWrapper>
      <StyledTitle display='block'>{title}</StyledTitle>
      {children}
    </ModalContent>
  </ModalContainerWithBackdrop>
);

export default BasketModal;
